import { IconProps } from "../../utils/global-types/global-types";

const AnalyticsTwoIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_3874_47994)">
        <path d="M8.494 3.012a6.494 6.494 0 1 0 6.494 6.494H8.494z"></path>
        <path d="M9.506 2v6.494H16A6.494 6.494 0 0 0 9.506 2"></path>
      </g>
      <defs>
        <clipPath id="clip0_3874_47994">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AnalyticsTwoIcon;
